import { supabase } from '../supabaseClient';

async function getAllCounts(year, usersarray, projectarray) {
    let { data, error } = await supabase.rpc('dashboardanalytics', { year: year, usersarray: usersarray, projectarray: projectarray ? projectarray : [] }).select('*')
    if (data) return data
    else throw error
}

async function getTopProjects(usersarray) {
    let { data, error } = await supabase.rpc('topprojects', { usersarray }).select('*')
    if (data) return data
    else throw error
}

async function getTopSalesByProject(projectId) {
    let { data, error } = await supabase.rpc('topsalesbyproject', { projectid: projectId }).select('*')
    if (data) return data
    else throw error
}

async function getTopCpByProject(projectId) {
    let { data, error } = await supabase.rpc('topcpbyproject', { projectid: projectId }).select('*')
    if (data) return data
    else throw error
}

async function getTopSales(usersarray, projectarray) {
    let { data, error } = await supabase.rpc('topsales', { usersarray: usersarray, projectarray: projectarray }).select('*')
    if (data) return data
    else throw error
}

async function getUniqueUnitTypes(projectId) {
    let { data, error } = await supabase.rpc('getuniqueunittypes', { pid: projectId }).select('*')
    if (data) return data
    else throw error
}

async function projectAnalytics(projectId) {
    let { data, error } = await supabase.rpc('projectanalytics', { projectid: projectId }).select('*')
    if (data) return data
    else throw error
}

async function getCountsByYearForProject(year, unitType, projectId) {
    let { data, error } = await supabase.rpc('getMonthlyDataForAnalyticsOfProject', { year: year, unittype: unitType, projectid: projectId }).select('*')
    if (data) return data
    else throw error
}

async function getProjects() {
    let { data, error } = await supabase.from('Projects').select('*').eq('isVJ', true)
    if (data) return data
    else throw error
}

async function getCp() {
    let { data, error } = await supabase.from('CP').select('*')
    if (data) return data
    else throw error
}

async function getTopFosByCp(cpId) {
    let { data, error } = await supabase.rpc('topfosbycp', { cpid: cpId })
    if (data) return data
    else throw error
}

async function cpAnalytics(cpId) {
    let { data, error } = await supabase.rpc('cpanalytics', { cpid: cpId })
    if (data) return data
    else throw error
}

async function getdataforcpdoughnut(year, cpId) {
    let { data, error } = await supabase.rpc('getdataforcpdoughnut', { year: year, cpid: cpId })
    if (data) return data
    else throw error
}

async function getTokenDataBySalesTeam(usersarray, projectarray) {
    let { data, error } = await supabase.rpc('salesteamanalysis', { usersarray: usersarray, projectarray: projectarray })
    if (data) return data
    else throw error
}

async function getUnitAnalysis(projectarray) {
    let { data, error } = await supabase.rpc('unitanalysis', { projectarray: projectarray })
    if (data) return data
    else throw error
}

async function getTokenWiseUnitsSold(projectarray) {
    let { data, error } = await supabase.rpc('tokenwiseunitssold', { projectarray: projectarray })
    if (data) return data
    else throw error
}

async function getTopSalesInEvent(projectarray) {
    let { data, error } = await supabase.rpc('topsalesinevent', { projectarray: projectarray })
    if (data) return data
    else throw error
}

async function getTopSalesInSustenance(projectarray) {
    let { data, error } = await supabase.rpc('topsalesinsustenance', { projectarray: projectarray })
    if (data) return data
    else throw error
}

export { getCp, cpAnalytics, getUnitAnalysis, getTopSalesInSustenance, getTopSalesInEvent, getTokenWiseUnitsSold, getTokenDataBySalesTeam, getdataforcpdoughnut, getTopFosByCp, getProjects, getAllCounts, getTopCpByProject, getTopSalesByProject, getTopSales, getTopProjects, getUniqueUnitTypes, projectAnalytics, getCountsByYearForProject }